export default __webpack_public_path__ + "static/media/logo-white.2625c17e.png";